var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Sliders'),_c('LatestProjects'),_c('GeneralDonation'),_c('TotalCount'),_c('LatestNews'),_c('WhoWeAre')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }